export default __webpack_public_path__ + "static/media/twitter.3da534c9.svg";